import { GET_INVENTORY_REPORT, GET_INVENTORY_REPORT_SUCCESS, GET_INVENTORY_REPORT_FAILED } from './constants';

const INIT_STATE = {
    loading: false,
    reportData: null,
    error: null
};

const Reports = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_INVENTORY_REPORT:
            return { ...state, loading: true, error: null };
        case GET_INVENTORY_REPORT_SUCCESS:
            return { ...state, loading: false, reportData: action.payload, error: null };
        case GET_INVENTORY_REPORT_FAILED:
            return { ...state, loading: false, error: action.payload };
        default:
            return state;
    }
};

export default Reports;
